import map from 'lodash/map'
import take from 'lodash/take'
import React, { useContext } from 'react'
import styled from 'styled-components'

import { ImageV2 } from '@Components/Image'
import { Link } from '@Components/Link'
import { NavigationEvent } from '@Events/Navigation'
import { MetadataContext } from '@Globals/Metadata'
import { useTranslation } from '@Globals/Translations'

interface WrapperProps {
  postTitleTextColor?: string
}

const Wrapper = styled.div<WrapperProps>`
  flex-shrink: 0;
  margin: 0 auto;
  width: 200px;

  .sectionTitle {
    width: 200px;
    display: block;
    font-size: 0.875rem;
    font-weight: bold;
    padding-bottom: 2px;
    text-transform: uppercase;
  }

  .cmsPostItem {
    display: block;
    width: 200px;
    margin-bottom: 10px;

    .postTitle {
      color: ${({ postTitleTextColor, theme }) => postTitleTextColor ?? theme.colors.grey};
      display: block;
      font-size: 0.75rem;
      padding-top: 3px;
    }
  }
`

export const CMSPosts = () => {
  const { t } = useTranslation()
  const { cmsData } = useContext(MetadataContext)

  return (
    <Wrapper>
      <span className="sectionTitle">{t('header:HEADER_MOBILE_MENU_GET_INSPIRED')}</span>

      {map(
        take(cmsData?.latestCollections || [], 2),
        collection => (
          <Link
            key={collection.id}
            className="cmsPostItem"
            event={new NavigationEvent({
              attributes: {
                dest_page_type: 'collections',
                dest_page_type_id: collection.id || '',
                source_id: 'mega_menu',
              },
              eventName: 'nav_link_click',
            })}
            href={collection?.url || ''}
          >
            <ImageV2
              key={collection.id}
              cropRatio="360:216"
              height="216"
              src={collection.image?.url || ''}
              width="360"
            />
            <span className="postTitle">{collection.title}</span>
          </Link>
        ),
      )}
    </Wrapper>
  )
}
